// components/ClaimStatusBadge.js
import React from "react";
import { Badge } from "@themesberg/react-bootstrap";
import { useTranslation } from "react-i18next";
 

const ClaimStatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const statusColors = {
    "Waiting for Admin Action": { bg: "warning", text: "dark", label: t("statuses.waitingAdminAction.value") },
    "In Process": { bg: "primary", label: t("Approve") },
    "Closed": { bg: "success", label: t("fixedStatuses.completed") },
    "Rejected": { bg: "danger", label: t("RejectedClaim") },
    "debtor has paid, payment coming soon": { bg: "#28a745", custom: true, label: t("fixedStatuses.paid") },
    "Installment payment agreement in place": { bg: "#17a2b8", custom: true, label: t("fixedStatuses.installmentPayment") },
    "In Progress": { bg: "#ffc107", custom: true, text: "#212529", label:t("fixedStatuses.debtCollectionInitiated") },
    "court dunning procedure": { bg: "#fd7e14", custom: true, label: t("fixedStatuses.courtDunningProcedure") },
    "we contact the debtor": { bg: "#6610f2", custom: true, label: t("fixedStatuses.resubmissions") },
    "enforcement order obtained": { bg: "#dc3545", custom: true, label: t("fixedStatuses.foreclosures") },
    "case closed": { bg: "#20c997", custom: true, label: t("fixedStatuses.completed") },
    "cancellation": { bg: "#6c757d", custom: true, label: t("fixedStatuses.cancellation") },
  };
  const config = statusColors[status] || { bg: "secondary", label: `${t("Approve")}` };
  if (config.custom) {
    return (
      <Badge
        style={{ backgroundColor: config.bg, color: config.text || "#fff" }}
      >
        {config.label}
      </Badge>
    );
  }

  return (
    <Badge bg={config.bg} text={config.text || undefined}>
      {config.label}
    </Badge>
  );
};

export default ClaimStatusBadge;
